<!-- filepath: c:\workspace-vsc-bitbucket\training-form\frontend\src\components\UserMenu.vue -->
<template>
  <nav class="bg-gray-800">
    <div class="mx-auto px-2 sm:px-6 lg:px-8">
      <div class="relative flex h-16 items-center justify-between">
        <div class="absolute inset-y-0 left-0 flex items-center sm:hidden">
          <button type="button"
            class="relative inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:ring-2 focus:ring-white focus:outline-none focus:ring-inset"
            aria-controls="mobile-menu" :aria-expanded="mobileMenuOpen.toString()" @click="toggleMobileMenu">
            <span class="absolute -inset-0.5"></span>
            <span class="sr-only">Open main menu</span>
            <svg v-if="!mobileMenuOpen" class="block size-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
              stroke="currentColor" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
            </svg>
            <svg v-else class="block size-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
              aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div class="flex flex-1 items-center justify-center sm:items-stretch sm:justify-start">
          <div class="flex shrink-0 items-center">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50.4 50.4" class="w-10">
              <path fill="#e95f2d"
                d="M50.4 25.3c0 13.9-11.4 25.2-25.3 25.1S0 39 0 25.1 11.4 0 25.3 0c13.8 0 25 11.3 25.1 25.1v.2" />
              <path fill="#fff"
                d="M40 30.1c-1.2-1.7-2.7-3.2-4.4-4.5 0-.4.1-.8.1-1.2.4-4.1-1.7-8.1-5.3-10.2-3.7-2.2-8.4-2.1-12 .4l2.7 4.1c2-1.4 4.6-1.5 6.7-.2 1.7 1 2.8 2.8 2.9 4.8-2.6-.8-5.5-1-8.2-.5-3.6.7-7 3.7-7.9 7-.6 2.3 0 4.7 1.9 6.2 2.6 2.3 6.2 2.7 9.7 1.1 3.1-1.4 5.6-3.8 7.4-6.7.8.7 1.6 1.6 2.2 2.5 2.8 4 3.6 8.8 3.1 13.4 1.8-1.2 3.5-2.7 5-4.4-.2-4.3-1.6-8.4-4.1-11.9m-15.4 2.6c-1.8.8-3.3.7-4.5-.3-.4-.3-.6-.8-.4-1.2.4-1.4 2.4-3.1 4.1-3.5 2-.4 4-.2 5.9.4-1.2 2-3 3.6-5.1 4.6" />
            </svg>
          </div>

          <div class="hidden sm:ml-6 sm:block">
            <div class="flex space-x-4">
              <template v-if="store.hasPermission('admin.home.read')">
                <router-link to="/admin/home" exact-active-class="bg-gray-900 text-white"
                  class="rounded-md px-3 py-2 text-sm font-medium text-gray-300 hover:bg-gray-700 hover:text-white">
                  Home
                </router-link>
                <router-link v-if="store.hasPermission('user.password.change')" to="/admin/change-password"
                  active-class="bg-gray-900 text-white"
                  class="rounded-md px-3 py-2 text-sm font-medium text-gray-300 hover:bg-gray-700 hover:text-white">
                  Cambia Password
                </router-link>
                <router-link v-if="store.hasPermission('user.home.read')" to="/home"
                  active-class="bg-gray-900 text-white"
                  class="rounded-md px-3 py-2 text-sm font-medium text-gray-300 hover:bg-gray-700 hover:text-white">
                  Naviga come Utente
                </router-link>
              </template>
              <template v-else-if="store.hasPermission('user.home.read')">
                <button @click="goToHome"
                  class="rounded-md px-3 py-2 text-sm font-medium text-gray-300 hover:bg-gray-700 hover:text-white"
                  :class="{ 'bg-gray-900 text-white': $route.path === '/home' }">
                  Home
                </button>
                <router-link to="/user/change-password" active-class="bg-gray-900 text-white"
                  class="rounded-md px-3 py-2 text-sm font-medium text-gray-300 hover:bg-gray-700 hover:text-white">
                  Cambia Password
                </router-link>
              </template>
            </div>
          </div>
        </div>
        <div class="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
          <div class="hidden sm:block mr-4">
            <span class="text-sm text-gray-300">
              {{ store.user?.username }}
              <span class="text-xs text-gray-400">
                ({{ store.isAdmin ? 'Admin' : store.isViewer ? 'Viewer' : 'User' }})
              </span>
            </span>
          </div>
          <button @click="logout"
            class="rounded-md bg-red-600 hover:bg-red-700 px-3 py-2 text-sm font-medium text-white transition-colors">
            Logout
          </button>
        </div>
      </div>
    </div>

    <div class="sm:hidden" id="mobile-menu" v-if="mobileMenuOpen">
      <div class="space-y-1 px-2 pt-2 pb-3">
        <div class="px-3 py-2 text-base font-medium text-gray-300 border-b border-gray-700 mb-2">
          {{ store.user?.username }} <span class="text-sm text-gray-400 block">{{ store.isAdmin ? 'Amministratore' :
            store.isViewer ? 'Viewer' : 'Utente' }}
          </span>
        </div>
        <template v-if="store.hasPermission('admin.home.read')">
          <router-link to="/admin/home" exact-active-class="bg-gray-900 text-white"
            class="block rounded-md px-3 py-2 text-base font-medium text-gray-300 hover:bg-gray-700 hover:text-white"
            @click="mobileMenuOpen = false">
            Home
          </router-link>
          <router-link v-if="store.hasPermission('admin.users.read')" to="/admin/user-management"
            active-class="bg-gray-900 text-white"
            class="block rounded-md px-3 py-2 text-base font-medium text-gray-300 hover:bg-gray-700 hover:text-white"
            @click="mobileMenuOpen = false">
            Gestione Utenti
          </router-link>
          <router-link v-if="store.hasPermission('user.password.change')" to="/admin/change-password" active-class="bg-gray-900 text-white"
            class="block rounded-md px-3 py-2 text-base font-medium text-gray-300 hover:bg-gray-700 hover:text-white"
            @click="mobileMenuOpen = false">
            Cambia Password
          </router-link>
          <router-link v-if="store.hasPermission('user.home.read')" to="/home" active-class="bg-gray-900 text-white"
            class="block rounded-md px-3 py-2 text-base font-medium text-gray-300 hover:bg-gray-700 hover:text-white"
            @click="mobileMenuOpen = false">
            Home Utente
          </router-link>
        </template>
        <template v-else-if="store.hasPermission('user.home.read')">
          <button @click="goToHome"
            class="block rounded-md px-3 py-2 text-base font-medium text-gray-300 hover:bg-gray-700 hover:text-white w-full text-left"
            :class="{ 'bg-gray-900 text-white': $route.path === '/home' }">
            <svg class="w-5 h-5 inline mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6">
              </path>
            </svg>
            Home
          </button>
          <router-link to="/user/change-password" active-class="bg-gray-900 text-white"
            class="block rounded-md px-3 py-2 text-base font-medium text-gray-300 hover:bg-gray-700 hover:text-white"
            @click="mobileMenuOpen = false">
            <svg class="w-5 h-5 inline mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z">
              </path>
            </svg>
            Cambia Password
          </router-link>
        </template>
        <button @click="logout"
          class="block w-full text-left rounded-md bg-red-600 hover:bg-red-700 px-3 py-2 text-base font-medium text-white transition-colors">
          <svg class="w-5 h-5 inline mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"></path>
          </svg>
          Logout
        </button>
      </div>
    </div>
  </nav>
</template>

<script setup>
import { ref } from 'vue'
import { useFormStore } from '../stores/formStore'
import { useRouter } from 'vue-router'
import { useFormReset } from '../composables/useFormReset'

const mobileMenuOpen = ref(false)
const store = useFormStore()
const router = useRouter()
const { resetFormState } = useFormReset()

const toggleMobileMenu = () => {
  mobileMenuOpen.value = !mobileMenuOpen.value
}

const logout = () => {
  store.logout()
  router.push('/login')
}

const goToHome = () => {
  resetFormState()
  if (router.currentRoute.value.path !== '/home') {
    router.push('/home')
  }
  mobileMenuOpen.value = false
}
</script>
